// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"54c5a75f","488":"e7715c15","720":"dff37dde","908":"1634a56f","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};